import React, { useEffect, useState } from 'react';
import _isEmpty from 'lodash/isEmpty';
import { useDispatch, useSelector } from 'react-redux';
import { List, ListItem, ListItemText } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { setCertSidebar, setSelectedCert, showProgress } from '../../redux/actions/DealershipActions';
import service from '../../apis/service';
import { apiEndpoints } from '../../constants/apiEndpoints';
import { ErrorToast } from '../utils/Utils';
import SideBarListStyles from '../../styles/SideBarListStyle';
import ShowProgress from '../ui/Backdrop';
import FloatButton from '../sidebar/FloatButton';
import { AddCertPopup } from './AddCertPopup';
import useSelectedCertInfo from './hooks/useSelectedCertInfo';

export function SidebarListCerts(props) {
  const { filterArray } = props;
  const dispatch = useDispatch();
  const fetchSelectedCertInfo = useSelectedCertInfo();
  const classes = SideBarListStyles();

  const selectedCert = useSelector((state) => state.certificateData.selectedCert);

  const [isOpenAddCert, setIsOpenAddCert] = useState(false);

  const value = props.value === undefined ? 0 : props.value;

  const fetchSidebarList = async () => {
    dispatch(showProgress(true));
    try {
      const res = await service.get(apiEndpoints.CERT_ALL_CERTS);
      dispatch(setCertSidebar(res));
      if (!_isEmpty(res)) {
        handleListItemClick(res[0]);
      }
    } catch (error) {
      ErrorToast(error);
    }
    dispatch(showProgress(false));
  };

  useEffect(() => {
    fetchSidebarList();
  }, []);

  const handleListItemClick = async (data = {}) => {
    dispatch(showProgress(true));

    if (!_isEmpty(data)) {
      dispatch(setSelectedCert(data));
    }
    dispatch(showProgress(false));
  };

  useEffect(() => {
    if (selectedCert?.id) {
      fetchSelectedCertInfo();
    }
  }, [selectedCert]);

  const myRefs = filterArray?.reduce((acc, val) => {
    acc[val.id] = React.createRef();
    return acc;
  }, {});

  useEffect(() => {
    myRefs[selectedCert.id]?.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  }, [selectedCert, filterArray]);

  const getJourneyCount = (count) => {
    const suffix = count > 1 ? 'Journeys' : 'Journey';
    return `${count} ${suffix}`;
  };

  const addNewCert = () => {
    setIsOpenAddCert(true);
  };

  const fabs = [
    {
      color: 'primary',
      className: classes.fab,
      icon: <AddIcon />,
      label: 'Add',
    },
    {
      color: 'primary',
      className: classes.fab,
      icon: <AddIcon />,
      label: 'Add',
    },
  ];

  return (
    <div className={classes.root}>
      <List component="nav" aria-label="secondary mailbox folder">
        {filterArray?.map((data) => (
          <div key={data.id} className={selectedCert.id === data.id ? classes.highlightItem : ''}>
            <ListItem
              id={`Item${data.id}`}
              key={data.id}
              button
              selected={selectedCert.id === data.id}
              className={classes.listStyling}
              onClick={() => handleListItemClick(data)}
              ref={myRefs[data.id]}
            >
              <ListItemText
                primary={
                  <div>
                    <p
                      className={`${
                        selectedCert.id === data.id ? classes.listTextSelected : classes.listTextNonSelected
                      }`}
                    >
                      {data.name}
                    </p>
                  </div>
                }
                secondary={
                  <div>
                    <div
                      className={
                        selectedCert.id === data.id ? classes.listSubTextSelected : classes.listSubTextNonSelected
                      }
                    >
                      <div className={classes.listSubTextJustify}>
                        <div className={classes.listItemId}>ID: {data?.id}</div>
                        <div> {getJourneyCount(data.journeyCount)}</div>
                        <div> {data.departmentTitle}</div>
                      </div>
                    </div>
                  </div>
                }
              />
            </ListItem>
          </div>
        ))}
      </List>
      <FloatButton fabs={fabs} value={value} mainTabID={17} onAddNewCert={addNewCert} />
      {isOpenAddCert && <AddCertPopup isOpenAddCert={isOpenAddCert} setIsOpenAddCert={setIsOpenAddCert} />}
      <ShowProgress />
    </div>
  );
}
